<template>
  <div class="apps-title">
    <h1 class="apps-title__title">
      Заказывайте в приложении и получите пиццу в подарок!
    </h1>

    <div class="apps-title__description">
      Подробности акции на странице FARFOR
      <br />
      в магазине приложений
    </div>
  </div>
</template>

<style scoped lang="scss">
.apps-title {
  width: 460px;

  &__title {
    margin-bottom: 24px;
    font-size: 32px;
    font-weight: 900;
  }

  &__description {
    font-size: 16px;
    font-weight: 800;
    line-height: 120%;
  }

  @include media('<tablet') {
    width: unset;

    &__title {
      font-size: 30px;
    }

    &__description {
      font-size: 14px;
    }
  }
}
</style>
